export const VIDEO_SOURCES = {
    desktop: {
        src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/33f788d14525279b1f373aaa23276e74-1764232643218/Header%202560x1293_V2',
        type: 'video/mp4',
    },
    mobile: {
        src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/1eff241404e27df89aed8b13feaaee51-1764232656525/Header%20582x900_V2',
        type: 'video/mp4',
    },
};

export const VIDEO_POSTER =
    'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto/v1/video-attachments/generic_asset/asset/33f788d14525279b1f373aaa23276e74-1764232643218/Header%202560x1293_V2.png';
